import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress, Typography } from "@material-ui/core";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import withSharedSnackbar from "../../HOCs/withSharedSnackbar";

// GraphQL Mutation
const DELETE_MODEL = gql`
  mutation DeleteModel($id: Int!, $clientLoginId: Int!) {
    deleteModel(id: $id, clientLoginId: $clientLoginId) {
      status
      message
    }
  }
`;

const DeleteModelModal = ({
  open,
  onClose,
  modelId,
  clientLoginId,
  refetchBrands,
  deleteModel, 
  onEditSuccess,
  openSnackbar
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!modelId) return;

    setLoading(true);
    try {
      const { data } = await deleteModel({
        variables: {
          id: modelId,
          clientLoginId,
        },
      });

      if (data.deleteModel.status) {
        onEditSuccess();
        onClose();
        openSnackbar(`${data.deleteModel.message}`, { variant: "success" });
        refetchBrands();
      } else {
        onClose();
        openSnackbar(`${data.deleteModel.message}`, { variant: "error" });
      }
    } catch (error) {
      onClose();
      openSnackbar(`${error}`, { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Model?</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete this model?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          variant="outlined"
          disabled={loading}
          style={{ borderRadius: 8 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="secondary"
          variant="contained"
          disabled={loading}
          style={{
            borderRadius: 8,
            backgroundColor: '#f44336', 
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#e53935', 
            }
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Yes, Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default graphql(DELETE_MODEL, {
  name: "deleteModel",
})(withSharedSnackbar(DeleteModelModal));



// WEBPACK FOOTER //
// ./src/components/Pages/modalConfigure/DeleteModelModal.jsx